import { render, staticRenderFns } from "./UserInbox.vue?vue&type=template&id=711d27c3&"
import script from "./UserInbox.vue?vue&type=script&lang=js&"
export * from "./UserInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports